import { useContext } from 'react';
import useSessionStore from '../../hooks/useSessionStore';
import ActivityFeed from '../pages/ActivityFeed';
import Chat from '../pages/Chat';
import pages, { pagesConfig } from '../config/pages';
import LeadsPage from '../pages/Leads';
import ISLeads from '../pages/InsideSalesDashboard/ISLeads';
import CRXDashboardPage from '../pages/CRXDashboard';
import CRXCoachOnboardingPage from '../pages/CRXCoachOnboarding';
import CRXCoachConfigurations from '../pages/CRXCoachConfigurations';
import ISCoachConfigurations from '../pages/ISCoachConfigurations';
import ISAvailability from '../pages/ISAvailability';
import RecipeEditor from '../pages/MealsPlanner/RecipeEditor/RecipeEditor';
import Analytics from '../pages/Analytics/Analytics';
import NavigationContext, { NavigationRouteType } from '../context/NavigationContext';

import MyCommissions from '../pages/MyCommissions';
import InsideSales from '../pages/InsideSalesDashboard/InsideSales';
import InsideSalesCommissions from '../pages/InsideSalesDashboard/InsideSalesCommissions';
import ContractsManager from '../components/ContractsManager/ContractsManager';
import ReusableContracts from '../pages/ReusableContracts';
import ACDashboardPage from '../pages/ACDashboard/CoachingDashboard';
import DataMigration from '../pages/DataMigration';
import ACLeadDashboardPage from '../pages/ACLeadDashboard';
import ISDashboardPage from '../pages/ISDashboard';

import CommissionsPage from '../pages/InsideSalesDashboard/CommissionsPage';
import InternalAssignments from '../pages/InternalAssignments';
import UserRoleManagement from '../pages/UserRoleManagement';
import InternalUsers from '../pages/InternalUsers';
import CoachVoice from '../pages/CoachVoice';
import PodSettings from '../pages/PodSettings';
import AICoachProfile from '../pages/AICoachProfile';
import CheckInThemes from '../pages/CheckInThemes';
import ReleaseNotes from '../pages/ReleaseNotes';
import AICoachInstagramIdentity from '../pages/AICoachInstagramIdentity';
import InstagramAnalytics from '../pages/InstagramAnalytics';
import SmartContextAnalytics from '../pages/SmartContextAnalytics';
import SDRLeadInbox from '../pages/SDRLeadInbox';
import MassTextOutreach from '../pages/MassTextOutreach';
import WebflowDeployer from '../pages/WebflowDeployer';
import DisputesPage from '../pages/Disputes/DisputesPage';
import CoachTaskAdminRoutes from './coachTaskAdmin/CoachTaskAdminRoutes';
import MealPlannerRoutes from './mealPlanner/mealPlannerRoutes';
import WorkoutsManagerRoutes from './workoutsManager/workoutsManagerRoutes';
import RecipesRoutes from './recipes';
import FormsRoutes from './forms';
import ConfigurationRoutes from './configurations/ConfigurationRoutes';
import ManageClientsRoutes from './manageClients/ManageClientsRoutes';
import AnnouncementsManagerRoutes from './announcementsManager/announcementsManagerRoutes';

const COACH_ROUTES = [
  {
    pageId: pages.MEAL_PLANNER,
    path: pagesConfig[pages.MEAL_PLANNER].path,
    component: MealPlannerRoutes,
  },
  {
    pageId: pages.ACTIVITY_FEED,
    path: pagesConfig[pages.ACTIVITY_FEED].path,
    component: ActivityFeed,
    defaultRoute: true,
  },
  {
    pageId: pages.CHAT,
    path: pagesConfig[pages.CHAT].path,
    component: Chat,
  },
  {
    pageId: pages.WORKOUTS_MANAGER,
    path: pagesConfig[pages.WORKOUTS_MANAGER].path,
    component: WorkoutsManagerRoutes,
  },
  {
    pageId: pages.LEADS,
    path: pagesConfig[pages.LEADS].path,
    component: LeadsPage,
  },
  {
    pageId: pages.CONFIG,
    path: pagesConfig[pages.CONFIG].path,
    component: ConfigurationRoutes,
  },
  {
    pageId: pages.MANAGE_CLIENTS,
    path: pagesConfig[pages.MANAGE_CLIENTS].path,
    component: ManageClientsRoutes,
  },
  {
    pageId: pages.COMMUNITY,
    path: pagesConfig[pages.COMMUNITY].path,
    component: AnnouncementsManagerRoutes,
  },
  {
    pageId: pages.INSTAGRAM_ANALYTICS,
    path: pagesConfig[pages.INSTAGRAM_ANALYTICS].path,
    component: InstagramAnalytics,
  },
];

const ADMIN_ROUTES = [
  // CRX routes
  {
    pageId: pages.CRX_DASHBOARD,
    path: pagesConfig[pages.CRX_DASHBOARD].path,
    component: CRXDashboardPage,
  },
  {
    pageId: pages.CRX_COACH_ONBOARDING,
    path: pagesConfig[pages.CRX_COACH_ONBOARDING].path,
    component: CRXCoachOnboardingPage,
  },
  {
    pageId: pages.ANALYTICS,
    path: pagesConfig[pages.ANALYTICS].path,
    component: Analytics,
  },
  {
    pageId: pages.MY_COMMISSIONS,
    path: pagesConfig[pages.MY_COMMISSIONS].path,
    component: MyCommissions,
  },
  {
    pageId: pages.FORMS,
    path: pagesConfig[pages.FORMS].path,
    component: FormsRoutes,
  },
  {
    pageId: pages.CRX_COACH_CONFIGS,
    path: pagesConfig[pages.CRX_COACH_CONFIGS].path,
    component: CRXCoachConfigurations,
  },
  // AC routes
  {
    pageId: pages.AC_DASHBOARD,
    path: pagesConfig[pages.AC_DASHBOARD].path,
    component: ACDashboardPage,
  },
  {
    pageId: pages.DATA_MIGRATION,
    path: pagesConfig[pages.DATA_MIGRATION].path,
    component: DataMigration,
  },
  {
    pageId: pages.AC_LEAD_DASHBOARD,
    path: pagesConfig[pages.AC_LEAD_DASHBOARD].path,
    component: ACLeadDashboardPage,
  },
  {
    pageId: pages.COACH_TASK_ADMIN,
    path: pagesConfig[pages.COACH_TASK_ADMIN].path,
    component: CoachTaskAdminRoutes,
  },
  {
    pageId: pages.AI_COACH_PROFILE,
    path: pagesConfig[pages.AI_COACH_PROFILE].path,
    component: AICoachProfile,
  },
  {
    pageId: pages.AI_COACH_INSTAGRAM_IDENTITY,
    path: pagesConfig[pages.AI_COACH_INSTAGRAM_IDENTITY].path,
    component: AICoachInstagramIdentity,
  },
  // IS routes
  {
    pageId: pages.INSIDE_SALES_DASHBOARD,
    path: pagesConfig[pages.INSIDE_SALES_DASHBOARD].path,
    component: ISDashboardPage,
  },
  {
    pageId: pages.INSIDE_SALES_LEADS,
    path: pagesConfig[pages.INSIDE_SALES_LEADS].path,
    component: ISLeads,
  },
  {
    pageId: pages.INSIDE_SALES,
    path: pagesConfig[pages.INSIDE_SALES].path,
    component: InsideSales,
  },
  {
    pageId: pages.INSIDE_SALES_COMMISSIONS,
    path: pagesConfig[pages.INSIDE_SALES_COMMISSIONS].path,
    component: InsideSalesCommissions,
  },
  {
    pageId: pages.INSIDE_SALES_CONTRACTS_MANAGER,
    path: pagesConfig[pages.INSIDE_SALES_CONTRACTS_MANAGER].path,
    component: ContractsManager,
  },
  {
    pageId: pages.IS_AVAILABILITY,
    path: pagesConfig[pages.IS_AVAILABILITY].path,
    component: ISAvailability,
  },
  // TODO: Move this to an admin-only route. We will limit access to this app for now.
  {
    pageId: pages.COMMISSIONS,
    path: pagesConfig[pages.COMMISSIONS].path,
    component: CommissionsPage,
  },
  {
    pageId: pages.IS_COACH_CONFIGS,
    path: pagesConfig[pages.IS_COACH_CONFIGS].path,
    component: ISCoachConfigurations,
  },
  {
    pageId: pages.INTERNAL_USERS,
    path: pagesConfig[pages.INTERNAL_USERS].path,
    component: InternalUsers,
  },
  // support
  {
    pageId: pages.RECIPE_EDITOR,
    path: pagesConfig[pages.RECIPE_EDITOR].path,
    component: RecipeEditor,
  },
  {
    pageId: pages.RECIPES,
    path: pagesConfig[pages.RECIPES].path,
    component: RecipesRoutes,
  },
  {
    pageId: pages.REUSABLE_CONTRACTS,
    path: pagesConfig[pages.REUSABLE_CONTRACTS].path,
    component: ReusableContracts,
  },
  {
    pageId: pages.INTERNAL_ASSIGNMENTS,
    path: pagesConfig[pages.INTERNAL_ASSIGNMENTS].path,
    component: InternalAssignments,
  },
  {
    pageId: pages.COACH_VOICE,
    path: pagesConfig[pages.COACH_VOICE].path,
    component: CoachVoice,
  },
  // User Management
  {
    pageId: pages.USER_MANAGEMENT,
    path: pagesConfig[pages.USER_MANAGEMENT].path,
    component: UserRoleManagement,
  },
  {
    pageId: pages.POD_SETTINGS,
    path: pagesConfig[pages.POD_SETTINGS].path,
    component: PodSettings,
  },
  {
    pageId: pages.CHECK_IN_THEMES,
    path: pagesConfig[pages.CHECK_IN_THEMES].path,
    component: CheckInThemes,
  },
  {
    pageId: pages.SMART_CONTEXT_ANALYTICS,
    path: pagesConfig[pages.SMART_CONTEXT_ANALYTICS].path,
    component: SmartContextAnalytics,
  },
  // Disputes
  {
    pageId: pages.DISPUTES,
    path: pagesConfig[pages.DISPUTES].path,
    component: DisputesPage,
  },
  {
    pageId: pages.RELEASE_NOTES,
    path: pagesConfig[pages.RELEASE_NOTES].path,
    component: ReleaseNotes,
  },
  // SDR routes
  {
    pageId: pages.SDR_LEAD_INBOX,
    path: pagesConfig[pages.SDR_LEAD_INBOX].path,
    component: SDRLeadInbox,
  },
  {
    pageId: pages.MASS_TEXT_OUTREACH,
    path: pagesConfig[pages.MASS_TEXT_OUTREACH].path,
    component: MassTextOutreach,
  },
  // Marketing routes
  {
    pageId: pages.WEBFLOW_DEPLOYER,
    path: pagesConfig[pages.WEBFLOW_DEPLOYER].path,
    component: WebflowDeployer,
  },
];

const RoutesMap = {
  [NavigationRouteType.ADMIN]: ADMIN_ROUTES,
};

const useRoutesConfig = () => {
  const { routeType } = useContext(NavigationContext);
  const sessionStore = useSessionStore();

  // Get the routes for the current type (Admin, Coach, etc.)
  let routes = RoutesMap[routeType] || COACH_ROUTES;

  if (routeType === NavigationRouteType.ADMIN) {
    routes = routes.filter((route) => {
      const permissions = sessionStore.getPagePermissions(route.pageId);
      return permissions && permissions.includes('EDIT');
    });
  }

  return routes;
};

export default useRoutesConfig;
